import { useCallback, useMemo } from 'react';
import { useTranslate, useApi } from '@shopify/ui-extensions-react/customer-account';
import { getOrderIdFromUrl } from '../utils/getOrderIdFromUrl';
import { useOrderDetails } from './useOrderDetails';
import { calculateSeatUploadRequirements } from '../utils/seatRequirements';
import { UseOrderStatusReturn } from '../types';

/**
 * @description Hook for the order status
 * @returns An object containing the order ID, order details, loading state, has seat products, handle close modal, and upload button text
 */
export const useOrderStatus = (): UseOrderStatusReturn => {
  const translate = useTranslate();
  const api = useApi<'customer-account.order-status.block.render'>();

  const apiOrderId = api.order?.current?.id;
  const urlOrderId = getOrderIdFromUrl();
  const orderId = apiOrderId || urlOrderId;

  const { orderDetails, loading } = useOrderDetails(orderId);

  console.log(orderId, orderDetails, loading);

  const hasSeatProducts = useMemo(() => {
    return orderDetails !== null && calculateSeatUploadRequirements(orderDetails) !== null;
  }, [orderDetails]);

  const handleCloseModal = useCallback(() => {
    // Modal close is handled by the hook, this is just for cleanup if needed
  }, []);

  const uploadButtonText = translate('uploadPhotosButton');

  return {
    orderId,
    orderDetails,
    loading,
    hasSeatProducts,
    handleCloseModal,
    uploadButtonText,
  };
};

